/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.0.0",
  "gitBuildTime": "2022-08-09T22:13:07.503Z",
  "gitBuildVersion": "1.0.0",
  "gitCommitId": "e84a054",
  "gitCommitIdFull": "e84a054751053c4f80d8d0f32cb62187675a4e94",
  "gitCommitTime": "2022-08-09T20:35:18.000Z",
  "version": "1.0.0-2022-08-09T20:35:18.000Z-(e84a054)"
};
